var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    { staticClass: "container container_40 transfer-confirm" },
    [
      _vm.isPending
        ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "md-title text_medium" }, [
        _vm._v(_vm._s(_vm.i18n.tr_confirm()))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "transfer-confirm__inner" },
        [
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.lbl_asset(),
              value: "" + _vm.opts.tokenCode
            }
          }),
          _vm._v(" "),
          _c("detail-row", {
            attrs: {
              prop: _vm.i18n.lbl_amount(),
              value: _vm.swimAmount + " " + _vm.opts.tokenCode
            }
          }),
          _vm._v(" "),
          [
            _c("div", { staticClass: "recipient__title" }, [
              _vm._v(_vm._s(_vm.i18n.lbl_recipient()))
            ]),
            _vm._v(" "),
            _c(
              "md-list",
              { staticClass: "md-double-line" },
              [
                _c(
                  "md-list-item",
                  [
                    _c(
                      "md-avatar",
                      { staticClass: "md-avatar-icon md-accent" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.opts.destinationEmail.charAt(0).toUpperCase()
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-list-item-text" }, [
                      _c("span", [_vm._v(_vm._s(_vm.opts.destinationEmail))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.opts.destinationAccountId))
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "md-layout md-gutter md-alignment-center-space-between transfer-confirm__fees"
            },
            [
              _c(
                "div",
                { staticClass: "md-layout-item md-size-45 md-small-size-100" },
                [
                  _c("div", { staticClass: "fees__title text_small" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_sender_fees()))
                  ]),
                  _vm._v(" "),
                  _c("detail-row", {
                    attrs: {
                      prop: _vm.i18n.lbl_fixed(),
                      value: _vm.senderFee.fixed + " " + _vm.opts.sourceFeeAsset
                    }
                  }),
                  _vm._v(" "),
                  _c("detail-row", {
                    attrs: {
                      prop: _vm.i18n.lbl_percent(),
                      value:
                        _vm.senderFee.percent + " " + _vm.opts.sourceFeeAsset
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "md-layout-item md-size-45 md-small-size-100 text-align-right"
                },
                [
                  _c("div", { staticClass: "fees__title text_small" }, [
                    _vm._v(_vm._s(_vm.i18n.lbl_recipient_fees()))
                  ]),
                  _vm._v(" "),
                  _c("detail-row", {
                    attrs: {
                      prop: _vm.i18n.lbl_fixed(),
                      value:
                        _vm.recipientFee.fixed +
                        " " +
                        _vm.opts.destinationFeeAsset
                    }
                  }),
                  _vm._v(" "),
                  _c("detail-row", {
                    attrs: {
                      prop: _vm.i18n.lbl_percent(),
                      value:
                        _vm.recipientFee.percent +
                        " " +
                        _vm.opts.destinationFeeAsset
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          [
            _c(
              "md-checkbox",
              {
                model: {
                  value: _vm.form.sourcePaysForDest,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "sourcePaysForDest", $$v)
                  },
                  expression: "form.sourcePaysForDest"
                }
              },
              [_vm._v(_vm._s(_vm.i18n.tr_pay_fee_for_rec()))]
            )
          ],
          _vm._v(" "),
          _vm.limitsList
            ? _c(
                "div",
                {
                  staticClass: "transfer__limits-container",
                  class: { loading: _vm.isFeesLoadPending }
                },
                [
                  _vm._l(_vm.limitsList, function(item, key) {
                    return [
                      item.period === "day"
                        ? _c("detail-row", {
                            attrs: {
                              prop: _vm.i18n.lim_daily_left(),
                              value: _vm.roundCurrency(
                                item.amount_limit - item.amount,
                                _vm.opts.tokenCode
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.period === "operation" || item.period === "day"
                        ? _c(
                            "div",
                            {
                              key: key,
                              class: {
                                "limits-operational":
                                  item.period === "operation"
                              }
                            },
                            [
                              item.period === "operation"
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.i18n.lim_withdrawal_daily_msg1({
                                          limit: item.amount_limit,
                                          asset: _vm.opts.tokenCode
                                        })
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.period === "day"
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.i18n.lim_withdrawal_daily_msg2({
                                          limit: item.amount_limit,
                                          asset: _vm.opts.tokenCode
                                        })
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              key === 0
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.i18n.lim_withdrawal_daily_msg3()
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h4", [_vm._v(_vm._s(_vm.i18n.lbl_subject()))]),
          _vm._v(" "),
          _c("textarea-field", {
            staticClass: "transfer-confirm__subject-field",
            attrs: { value: _vm.opts.subject, disabled: "" }
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap space-between" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { disabled: _vm.isPending },
              on: {
                click: function($event) {
                  return _vm.$emit(_vm.commonEvents.cancelClickEvent)
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_cancel()) + "\n    ")]
          ),
          _vm._v(" "),
          !_vm.amountLessThanFee && !_vm.amountGreaterThanBalance
            ? _c(
                "md-button",
                {
                  staticClass: "btn md-primary",
                  attrs: { disabled: _vm.isPending },
                  on: {
                    click: function($event) {
                      return _vm.$emit(
                        _vm.commonEvents.confirmClickEvent,
                        _vm.form.sourcePaysForDest
                      )
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.i18n.lbl_confirm()) + "\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fec8910", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fec8910","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/transfers/make/Transfers.Confirm.vue
// module id = PkjS
// module chunks = 1